import {
  SET_EDIT_MULTI_LOADING,
  SET_EDIT_MULTI_DATA,
  SET_EDIT_MULTI_DATA_ERROR,
} from './actionTypes'

const initialState = {
  data: {},
  isLoading: false,
}

const reducer = (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case SET_EDIT_MULTI_LOADING:
      return {
        ...state,
        isLoading: payload,
      }

    case SET_EDIT_MULTI_DATA:
      return {
        ...state,
        isLoading: false,
        data: payload,
      }
    case SET_EDIT_MULTI_DATA_ERROR:
      return {
        ...state,
        isLoading: false,
      }

    default:
      return state
  }
}

export default reducer
